module.exports = __webpack_public_path__ + "img/kazhua.prt.d3466b43.jpg";